import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import { Origin } from '@classes/origin/origin';
import { Region } from '@classes/region';

@Injectable({
    providedIn: 'root'
})
export class OrganismService {

    private baseUrl = environment.apiUrl + 'organisms';

    constructor(
        private http: HttpClient
    ) { }

    getList(params: {withLicence?: boolean, fromOrigin?: boolean, isTest?: boolean, withUserOrigin?: boolean}): Observable<Origin[]> {
        let httpParams = new HttpParams();

        Object.keys(params).map(key => {
            httpParams = httpParams.append(key, params[key].toString());
        });

        return this.http.get<Origin[]>(this.baseUrl, {params: httpParams});
    }

    getRegions(includeOrganisms: boolean): Observable<Region[]> {
        const httpParams = new HttpParams()
            .append("includeOrganisms", includeOrganisms ? "true" : "false");

        return this.http.get<Region[]>(`${this.baseUrl}/regions`, {params: httpParams});
    }
}
